// Copyright (c) 2026. Hardfin, Inc. All rights reserved.

/**
 * The colours a SKU can take in the chart and on its chip.
 *
 * The theme carries six semantic hues, and their light and dark variants are
 * too close to tell apart in a stacked bar. A report routinely covers ten SKUs
 * or more, so this is a categorical scale rather than palette tokens. The order
 * puts unlike hues next to each other, so adjacent stack segments separate even
 * before the chips are read.
 *
 * The values read the same in both themes, which is why they do not vary with
 * the mode.
 */
const SKU_COLORS = [
  '#4E79A7', // Blue
  '#F28E2B', // Orange
  '#59A14F', // Green
  '#E15759', // Red
  '#B07AA1', // Purple
  '#76B7B2', // Teal
  '#EDC948', // Yellow
  '#FF9DA7', // Pink
  '#9C755F', // Brown
  '#8CD17D', // Light green
  '#499894', // Dark teal
  '#D37295', // Rose
  '#A0CBE8', // Pale blue
  '#FFBE7D', // Pale orange
  '#B6992D', // Olive
  '#79706E', // Grey
];

/**
 * One colour per SKU, fixed by position so a SKU keeps its colour between
 * renders. A report with more SKUs than the scale holds wraps, which is why the
 * chips carry the colour rather than leaving the chart to identify them.
 */
export function toSkuColors(itemSkus: string[]): Record<string, string> {
  const out: Record<string, string> = {};
  itemSkus.forEach((itemSku, index) => {
    out[itemSku] = SKU_COLORS[index % SKU_COLORS.length];
  });
  return out;
}
